<script setup lang="ts">
import { NxtButton } from '@future-harry/nxt-styles';

defineProps<{
   disabled?: boolean;
}>();

defineEmits<{
   (e: 'onClick'): void;
}>();
</script>

<template>
   <NxtButton class="nxt-button-theme" :disabled="disabled" @click="$emit('onClick')">
      <slot />
   </NxtButton>
</template>

<style scoped lang="scss">
.nxt-button-theme {
   position: relative;
   background-color: var(--jobsite-primary);
   color: var(--jobsite-primary-font);
   border: 0;
   transition: box-shadow 0.2s ease;

   &::after {
      position: absolute;
      content: '';
      width: 100%;
      height: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(255, 255, 255, 0.15);
   }

   &:hover:not(:disabled) {
      &:after {
         height: 100%;
      }
   }
}
</style>
